module.exports = __webpack_public_path__ + "media/images/icon-close-lsd-57c29d87567dceed6c9d0e957a5c4122.svg";